/** InsCoder WANG.J 2026-09-15 B + Product quality brand message **/
(function () {
  'use strict';

  var scriptMarker = 'data-product-quality-message-script';

  if (document.documentElement.hasAttribute(scriptMarker)) {
    document.dispatchEvent(new CustomEvent('product-quality-message:refresh'));
    return;
  }

  document.documentElement.setAttribute(scriptMarker, '');

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var resizeTimer;

  function syncDesktopMediaMinHeight(component) {
    var desktopMedia = component.querySelector('.cust-product-quality-message__media--desktop');
    if (!desktopMedia) return;

    if (component.productQualityHeightFrame) {
      window.cancelAnimationFrame(component.productQualityHeightFrame);
    }

    desktopMedia.style.minHeight = '';

    if (mobileQuery.matches) return;

    component.productQualityHeightFrame = window.requestAnimationFrame(function () {
      var componentHeight = Math.ceil(component.getBoundingClientRect().height);
      var desktopMediaMaxHeight = parseFloat(window.getComputedStyle(desktopMedia).maxHeight);
      var syncedHeight = isNaN(desktopMediaMaxHeight)
        ? componentHeight
        : Math.max(componentHeight, desktopMediaMaxHeight);

      if (syncedHeight > 0) {
        desktopMedia.style.minHeight = syncedHeight + 'px';
      }

      component.productQualityHeightFrame = null;
    });
  }

  function bindMediaLoadEvents(component) {
    if (component.hasAttribute('data-product-quality-message-media-bound')) return;

    component.setAttribute('data-product-quality-message-media-bound', '');

    component.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) {
        image.addEventListener('load', refresh, { once: true });
      }
    });

    component.querySelectorAll('video').forEach(function (video) {
      if (video.readyState < 1) {
        video.addEventListener('loadedmetadata', refresh, { once: true });
      }
    });
  }

  function syncVideos(component) {
    var activeMediaSelector = mobileQuery.matches
      ? '.cust-product-quality-message__media--mobile'
      : '.cust-product-quality-message__media--desktop';
    var activeMedia = component.querySelector(activeMediaSelector);

    component.querySelectorAll('video').forEach(function (video) {
      var shouldPlay = activeMedia && activeMedia.contains(video) && !reducedMotionQuery.matches;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      if (shouldPlay) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
      }
    });
  }

  function positionComponent(component) {
    var productSection = component.closest('.product-section');
    if (!productSection) return;

    var productGrid = productSection.querySelector('.page-content--product > .page-width > .grid');
    var productImages = productSection.querySelector('[data-product-images]');
    if (!productGrid || !productImages) return;

    if (mobileQuery.matches) {
      if (productGrid.lastElementChild !== component) {
        productGrid.appendChild(component);
      }
    } else if (productImages.nextElementSibling !== component) {
      productImages.insertAdjacentElement('afterend', component);
    }

    syncVideos(component);
    bindMediaLoadEvents(component);
    syncDesktopMediaMinHeight(component);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var components = [];

    if (root.matches && root.matches('[data-product-quality-message]')) {
      components.push(root);
    }

    root.querySelectorAll('[data-product-quality-message]').forEach(function (component) {
      components.push(component);
    });

    components.forEach(positionComponent);
  }

  function refresh() {
    init(document);
  }

  document.addEventListener('product-quality-message:refresh', refresh);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    init(event.target.closest('.product-section') || event.target);
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', refresh);
    reducedMotionQuery.addEventListener('change', refresh);
  } else {
    mobileQuery.addListener(refresh);
    reducedMotionQuery.addListener(refresh);
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refresh, 100);
  });

  window.addEventListener('load', refresh, { once: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
/** InsCoder WANG.J 2026-09-15 E + Product quality brand message **/
